// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"5c493faa","542":"50c25dc6","646":"13f9680d"}[chunkId] + ".chunk.js";
};